import { DeepReadonly, IFieldMappingList } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultFieldMappings: DeepReadonly<IFieldMappingList> = deepFreeze({
  intakeId: {
    uniField: 'INTAKE_ID',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  offerId: {
    uniField: 'OFFER_ID',
    format: 'MAP2',
    mappingType: 'MAP_OFFER_ID_UNKNOWN',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  email: {
    uniField: 'GOREMAL_EMAIL_ADDRESS',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  studentNo: {
    uniField: 'SPRIDEN_ID',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  familyName: {
    uniField: 'SPRIDEN_LAST_NAME',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  givenName: {
    uniField: 'SPRIDEN_FIRST_NAME',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  otherName: {
    uniField: 'SPRIDEN_MI',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Disabled'
  },
  phone: {
    uniField: 'SPRTELE_PHONE_NUMBER',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  dob: {
    uniField: 'SPBPERS_BIRTH_DATE',
    format: 'DATE3',
    validationType: 'DATE',
    setup: 'Mandatory'
  },
  gender: {
    uniField: 'SPBPERS_SEX',
    format: 'GENDER',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  agentCompany: {
    uniField: 'AGENT_COMPANY',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  agentCompanyEmail: {
    uniField: 'AGENT_COMPANY_EMAIL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  agentEmail: {
    uniField: 'AGENT_EMAIL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  agentOffice: {
    uniField: 'AGENT_OFFICE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  branchOffice: {
    uniField: 'AGENT_OFFICE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  companyName: {
    uniField: 'COMPANY_NAME',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  counsellorEmail: {
    uniField: 'COUNSELLOR_EMAIL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  counsellorName: {
    uniField: 'COUNSELLOR_NAME',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  addressLine1: {
    uniField: 'SPRADDR_STREET_LINE1',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  addressLine2: {
    uniField: 'SPRADDR_STREET_LINE2',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  addressLine3: {
    uniField: 'SPRADDR_STREET_LINE3',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  city: {
    uniField: 'SPRADDR_CITY',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  agentName: {
    uniField: 'AGENT_NAME',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  withAgent: {
    uniField: 'WITH_AGENT',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  nationality: {
    uniField: 'SPRADDR_NATN_CODE',
    format: 'ISO-3166-1 ALPHA-3 (Nationality)',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  country: {
    uniField: 'SPRADDR_COUNTRY',
    format: 'ISO-3166-1 ALPHA-3 (Country)',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  countryOfBirth: {
    uniField: 'GOBINTL_NATN_CODE_BIRTH',
    format: 'ISO-3166-1 ALPHA-3 (Country)',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  postcode: {
    uniField: 'SPRADDR_OVERSEAS_POSTCODE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  admissionsOffice: {
    uniField: 'ADMISSIONS_OFFICE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Disabled'
  },
  passportNumber: {
    uniField: 'GOBINTL_PASSPORT_ID',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  passportExpiry: {
    uniField: 'GOBINTL_PASSPORT_EXP_DATE',
    format: 'DATE3',
    validationType: 'DATE',
    setup: 'Secondary'
  },
  placeOfBirth: {
    uniField: 'PLACE_OF_BIRTH',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  ucasId: {
    uniField: 'SKRSAIN_UCASNUM',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  applicationId: {
    uniField: 'SKRUCCR_APPLICANT_NO',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  englishLevelAttained: {
    uniField: 'SKRICAS_SELT_LVL_ATT',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  seltSpeaking: {
    uniField: 'SKRICAS_SELT_LVL_SPEAK',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  seltListening: {
    uniField: 'SKRICAS_SELT_LVL_LIST',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  seltReading: {
    uniField: 'SKRICAS_SELT_LVL_READ',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  seltWriting: {
    uniField: 'SKRICAS_SELT_LVL_WRITE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  englishTestProvider: {
    uniField: 'SKRICAS_SELT_TEST_PROV',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  prevUKStudy: {
    uniField: 'SKRICAS_PREV_UK_STU',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  criminalConvictions: {
    uniField: 'CRIMINAL_CONVICTIONS',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  previousCourseCompletion: {
    uniField: 'PREVIOUS_COURSE',
    format: 'DATE3',
    validationType: 'DATE',
    setup: 'Secondary'
  },
  applicationDate: {
    uniField: 'APPLICATION_DATE',
    format: 'TEXT',
    validationType: 'DATE',
    setup: 'Secondary'
  },
  confirmed: {
    uniField: 'CONFIRMED',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  offers_courses_id: {
    uniField: 'SORLCUR_PROGRAM',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_title: {
    uniField: 'SMRPCMT_TEXT',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  offers_courses_inner_london: {
    uniField: 'CAMPUS_CODE',
    format: 'NUMBER',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  offers_courses_cah3: {
    uniField: 'COURSE_CAH3',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditional: {
    uniField: 'FD',
    format: 'C_OR_U',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  offers_courses_faculty: {
    uniField: 'COURSE_FACULTY',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Disabled'
  },
  offers_courses_conditions_text1: {
    uniField: 'COURSE_CONDITIONAL_TEXT_1',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text2: {
    uniField: 'COURSE_CONDITIONAL_TEXT_2',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text3: {
    uniField: 'COURSE_CONDITIONAL_TEXT_3',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text4: {
    uniField: 'COURSE_CONDITIONAL_TEXT_4',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text5: {
    uniField: 'COURSE_CONDITIONAL_TEXT_5',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text6: {
    uniField: 'COURSE_CONDITIONAL_TEXT_6',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text7: {
    uniField: 'COURSE_CONDITIONAL_TEXT_7',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text8: {
    uniField: 'COURSE_CONDITIONAL_TEXT_8',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_conditions_text9: {
    uniField: 'COURSE_CONDITIONAL_TEXT_9',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_declined: {
    uniField: 'AD',
    format: 'D_OR_F',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },

  offers_courses_level: {
    uniField: 'SZRSPMY_STAGE_LEVEL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_secondaryLevel: {
    uniField: 'SECONDARY_LEVEL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_start_date: {
    uniField: 'SKRICAS_VISA_START_DT',
    format: 'DATE3',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  offers_courses_end_date: {
    uniField: 'SKRICAS_EXP_CRS_END_DT',
    format: 'DATE3',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  offers_courses_atas: {
    uniField: 'COURSE_ATAS',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  offers_courses_fee: {
    uniField: 'SKRICAS_CRSE_FEE_FYO',
    format: 'DOUBLE_COURSE_FEE',
    validationType: 'STRING',
    setup: 'Mandatory'
  },
  courseFeePaidToDate: {
    uniField: 'SKRICAS_CRSE_FEE_PTD',
    format: 'NUMBER',
    validationType: 'NUMBER',
    setup: 'Mandatory'
  },
  offers_courses_lastAcceptanceDate: {
    uniField: 'SKRICAS_LATST_ACC_DATE',
    format: 'TEXT',
    validationType: 'DATE',
    setup: 'Secondary'
  },
  offers_courses_isFullTime: {
    uniField: 'SKRUDAP_SSDT_CODE_PMOD',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  offers_courses_hoursPerWeek: {
    uniField: 'HOURS_PER_WEEK',
    format: 'NUMBER',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  mainStudyAddressLine1: {
    uniField: 'ADDR_STREET_LINE1',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  mainStudyAddressLine2: {
    uniField: 'ADDR_STREET_LINE2',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  mainStudyAddressLine3: {
    uniField: 'ADDR_STREET_LINE3',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  mainStudyAddressCity: {
    uniField: 'ADDR_CITY',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  mainStudyAddressCountry: {
    uniField: 'ADDR_COUNTRY',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  mainStudyAddressPostcode: {
    uniField: 'MN_SITE_STUDY_PO',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  isAccomProvided: {
    uniField: 'SKRICAS_SPON_ACCOM_IND',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  isAccomIncludedCourseFee: {
    uniField: 'SKRICAS_CRSE_FEE_INC_ACCOM_IND',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  accomFeePaidToDate: {
    format: 'NUMBER',
    mappingType: 'string',
    setup: 'Secondary',
    uniField: 'SKRICAS_ACCOM_FEE_PTD',
    validationType: 'NUMBER'
  },
  isWorkPlacement: {
    uniField: 'SKRICAS_APP_HS_WRK_PLMT',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  workPlacementPerc: {
    uniField: 'SKRICAS_WRK_PLMT_PERCENT',
    format: 'NUMBER',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  workPlacementText: {
    uniField: 'SKRICAS_WRK_PLMT_JUSTIF',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  workPlacementAddressLine1: {
    uniField: 'WRK_PLMT_ADDR_1',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  workPlacementAddressLine2: {
    uniField: 'WRK_PLMT_ADDR_2',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  workPlacementAddressLine3: {
    uniField: 'WRK_PLMT_ADDR_3',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  workPlacementAddressCity: {
    uniField: 'WRK_PLMT_ADDR_L',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  workPlacementAddressCountry: {
    uniField: 'WRK_PLMT_ADDR_C',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  workPlacementAddressPostcode: {
    uniField: 'WRK_PLMT_ADDR_POST_CODE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  isSELTReqd: {
    uniField: 'SKRICAS_SELT_REQ',
    format: 'Y_OR_N',
    validationType: 'BOOLEAN',
    setup: 'Secondary'
  },
  reasonSELTNotReqd: {
    uniField: 'SKRICAS_SELT_REA_NOT_REQ',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  previousCourseLevel: {
    uniField: 'SKRICAS_PREV_CRS_LVL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  courseProgression: {
    uniField: 'SKRICAS_PREV_CURR_LVL',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  progressionText: {
    uniField: 'SKRICAS_CURR_CRS_JUST',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  docsUsedToObtainOffer: {
    uniField: 'SKRICAS_DOC_OFFR',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_scholarshipTitle1: {
    uniField: 'SCHOLARSHIP_TITLE',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_scholarshipAmount1: {
    uniField: 'SCHOLARSHIP_AMOUNT',
    format: 'NUMBER',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  isPSEnglish: {
    setup: 'Mandatory',
    uniField: 'IS_P_S_ENGLISH',
    validationType: 'BOOLEAN',
    format: 'TRUE_OR_FALSE'
  },
  offers_presessional_title: {
    uniField: 'Pre-sessionalTitle',
    format: 'TEXT_OR_BLANK',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_presessional_start_date: {
    uniField: 'Pre-sessionalStartDate',
    format: 'TEXT_OR_BLANK',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_presessional_end_date: {
    uniField: 'Pre-sessionalEndDate',
    format: 'TEXT_OR_BLANK',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_presessional_fee: {
    uniField: 'Pre-sessionalCourseFee',
    format: 'TEXT_OR_BLANK',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_offerEvidence: {
    uniField: 'offerEvidence',
    format: 'TEXT',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_accepted: {
    uniField: 'coursesAccepted',
    format: 'TRUE_OR_FALSE',
    validationType: 'BOOLEAN',
    setup: 'Disabled'
  },
  externalCasStatus: {
    format: 'TEXT',
    uniField: 'offers_SMS_CAS_Status',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offersDurationMonths: {
    format: 'NUMBER',
    uniField: 'offers_duration_months',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  offers_courses_qual_hecos1: {
    format: 'TEXT',
    uniField: 'offers_courses_qual_hecos1',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_qual_hecos2: {
    format: 'TEXT',
    uniField: 'offers_courses_qual_hecos2',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_qual_hecos3: {
    format: 'TEXT',
    uniField: 'offers_courses_qual_hecos3',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_qual_hecos4: {
    format: 'TEXT',
    uniField: 'offers_courses_qual_hecos4',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_qual_hecos5: {
    format: 'TEXT',
    uniField: 'offers_courses_qual_hecos5',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  offers_courses_qual_proportion1: {
    format: 'NUMBER',
    uniField: 'offers_courses_qual_proportion1',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  offers_courses_qual_proportion2: {
    format: 'NUMBER',
    uniField: 'offers_courses_qual_proportion2',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  offers_courses_qual_proportion3: {
    format: 'NUMBER',
    uniField: 'offers_courses_qual_proportion3',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  offers_courses_qual_proportion4: {
    format: 'NUMBER',
    uniField: 'offers_courses_qual_proportion4',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  offers_courses_qual_proportion5: {
    format: 'NUMBER',
    uniField: 'offers_courses_qual_proportion5',
    validationType: 'NUMBER',
    setup: 'Secondary'
  },
  offers_courses_qual_cat: {
    format: 'TEXT',
    uniField: 'offers_courses_qual_cat',
    validationType: 'STRING',
    setup: 'Secondary'
  },
  scholarshipAmount: {
    format: 'NUMBER',
    setup: 'Secondary',
    uniField: 'SCHOLARSHIP_AMOUNT',
    validationType: 'NUMBER'
  },
  scholarshipTitle: {
    format: 'TEXT',
    setup: 'Secondary',
    uniField: 'SCHOLARSHIP_TITLE',
    validationType: 'STRING'
  },
  offers_courses_fee_discount: {
    format: 'NUMBER',
    setup: 'Secondary',
    uniField: 'OFFERS_COURSES_FEE_DISCOUNT',
    validationType: 'NUMBER'
  }
});
